<template>
  <v-card class="elevation-12">
    <v-toolbar
      color=""
      dark
      flat
    >
      <v-toolbar-title>Forget Password</v-toolbar-title>
    </v-toolbar>
    <v-form @submit.prevent="forgetPassowrd">
      <v-card-text>
        <v-text-field
          v-model="email"
          label="Your Email"
          name="email"
          prepend-icon="mdi-email"
          type="email"
          :error-messages="errors.getMessage('email')"
        />
      </v-card-text>
      <v-card-actions>
        <v-btn :to="{ name: 'Login' }">
          Back to login
        </v-btn>
        <v-spacer />
        <v-btn
          color="primary"
          type="submit"
        >
          Confirm Email
        </v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      email: "",
    };
  },
  computed: {
    ...mapGetters({
      errors: "validation/pull",
    }),
  },

  methods: {
    ...mapActions({
      alert: "snackbar/show",
    }),
    forgetPassowrd() {
      window.axios
        .post("/password/email", { email: this.email })
        .then((response) => {
          this.alert(response.data.message);
          this.$router.replace({ name: "Login" });
        });
    },
  },
};
</script>
